import React, { useMemo } from 'react'
import zxcvbn from 'zxcvbn'

const scoreToLabel = (score) => {
  switch (score) {
    case 0: return 'Very weak'
    case 1: return 'Weak'
    case 2: return 'Fair'
    case 3: return 'Good'
    case 4: return 'Strong'
    default: return ''
  }
}

const scoreToColor = (score) => {
  switch (score) {
    case 0: return 'bg-red-500'
    case 1: return 'bg-orange-500'
    case 2: return 'bg-yellow-500'
    case 3: return 'bg-green-500'
    case 4: return 'bg-emerald-600'
    default: return 'bg-gray-400'
  }
}

const PasswordStrengthMeter = ({ password }) => {
  const result = useMemo(() => (password ? zxcvbn(password) : { score: 0 }), [password])
  const score = result.score || 0

  const bars = [0,1,2,3].map((i) => (
    <div key={i} className={`h-1 rounded ${i <= score - 1 ? scoreToColor(score) : 'bg-gray-300 dark:bg-gray-600'}`}></div>
  ))

  return (
    <div className="mt-2">
      <div className="grid grid-cols-4 gap-1">
        {bars}
      </div>
      <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">
        {password ? scoreToLabel(score) : ''}
      </div>
    </div>
  )
}

export default PasswordStrengthMeter


